import { usePrevious } from "@react-hookz/web";
import { useEffect } from "react";
import { isCreatableMarkerOption } from "../utils";

/**
 * Hook to handle setting appropriate highlight index when options are loading.
 * Does nothing if highlightFirstOptionAutomatically is false.
 */
export const useAutoHighlightWithLoading = (setHighlightedIndex, options, isLoading, selectFirstAutomatically, isCreatable, input) => {
  const previousOptions = usePrevious(options);
  useEffect(() => {
    if (selectFirstAutomatically) {
      if (isLoading) {
        setHighlightedIndex(-1);
      } else {
        // options should always be stable across renders, so when changes it
        // means there's a new list of options. In this case, we'll try and
        // re-highlight the first option if necessary. This helps in cases like
        // async option loading.
        if (previousOptions !== options) {
          if (options && options.length > 0) {
            setHighlightedIndex(1);
          } else {
            setHighlightedIndex(isCreatable ? 0 : -1);
          }
        } else {
          if (input.length === 0) {
            // User has deleted input, set highlight to first option.
            setHighlightedIndex(0);
          } else {
            // if creatable, skip the "add" option and place highlight at first real option
            // otherwise place highlight at the top
            setHighlightedIndex(isCreatable && options.length > 1 && isCreatableMarkerOption(options[0]) ? 1 : 0);
          }
        }
      }
    }
  }, [input.length, isCreatable, isLoading, options, previousOptions, selectFirstAutomatically, setHighlightedIndex]);
};
//# sourceMappingURL=useAutoHighlightWithLoading.js.map